import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import {
	ORDERLOCATIONS,
	ORDERLOCATIONS_ADD,
	ORDERLOCATIONS_DELETE,
	GET_Location_ROW_DATA,
} from "./actionTypes";

import {
	apiError,
	getORDERLocations,
	ORDERlocationListSuccessful,
	locationAddSuccessful,
	locationRowDataSuccessful,
	model_close,
} from "./action";

import {
	postAdd,
	putImg,
	getList,
	getParamsList,
	postEdit,
	postDelete,
} from "../../../helpers/Helper";
import swal from "sweetalert";

function* getORDERLocation({ payload: { data } }) {
	var params = {};

	for (const k in data) {
		if (Object.hasOwnProperty.call(data, k)) {
			if (k === "currentSort" || k === "sortOrder") {
				params.ordering = data.sortOrder + data.currentSort;
			} else {
				if (data[k] !== "") {
					params[k] = data[k];
				}
			}
		}
	}
	try {
		const response = yield call(
			getParamsList,
			"/masters/orderlocations/",
			params
		);

		yield put(ORDERlocationListSuccessful({ response }));
		// yield put(changeSidebarTypeAction("icon"));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* GetOrderLocationRowData({ payload: { LocId } }) {
	try {
		const response = yield call(
			getList,
			"/masters/orderlocations/" + LocId,
			{}
		);
		yield put(
			locationRowDataSuccessful({
				response: {
					...response,
					image: response.image
						? response.image
						: {
								name: "",
								url: "",
								preview: "",
								type: "",
								size: 0,
						  },
					locationsLabel: response.location
						? response.location.name
						: "",
					location_id: response.location ? response.location.id : "",
					sublocationLabel: response.sublocation
						? response.sublocation.name
						: "",
					sublocation_id: response.sublocation
						? response.sublocation.id
						: "",
				},
			})
		);
	} catch (error) {
		// swal(error[0], {
		//   icon: "error",
		//   timer: 1500,
		// });
		yield put(apiError(error));
	}
}

function* ADDORDERLOCATIONS({
	payload: { data, image, fileType, LoId, history, model },
}) {
	
    delete data.image;

	try {
		if (!LoId) {
			// ADD CASE
			const response = yield call(
				postAdd,
				"/masters/orderlocations/",
				data
			);

			if (response.status === 201) {
				if (image) {
					console.log(image, "imageimage");
					console.log(fileType, "fileType");
					const response2 = yield call(
						putImg,
						`/masters/orderlocations/${response.data.id}`,
						{
							file: image,
							name: "image", // ✅ dynamic field name
						}
					);

					if (response2.status === 200) {
						swal("Your Order Location Added Successfully!", {
							icon: "success",
							timer: 1500,
						});
						if (model) {
							yield put(getORDERLocations());
						} else {
							history.push("/OrderLocations");
						}
					} else {
						swal("Unable to upload file. Please try again!", {
							icon: "error",
							timer: 1500,
						});
					}
				} else {
					swal("Your Order Location Added Successfully!", {
						icon: "success",
						timer: 1500,
					});
					if (model) yield put(getORDERLocations());
					else history.push("/OrderLocations");
				}
			} else {
				swal("Unable to add Order Location. Please try again!", {
					icon: "error",
					timer: 1500,
				});
			}

			yield put(locationAddSuccessful(null));
		} else {
			// EDIT CASE
			const response = yield call(
				postEdit,
				`/masters/orderlocations/${LoId}`,
				data
			);

			if (response.status === 200) {
				console.log("000000");
				if (image) {
					console.log(image, "imageimage");
					console.log(fileType, "fileType");

					const response2 = yield call(
						putImg,
						`/masters/orderlocations/${response.data.id}`,
						{
							file: image,
							name: "image", // ✅ dynamic field name
						}
					);

					if (response2.status === 200) {
						swal("Your Order Location Updated Successfully!", {
							icon: "success",
							timer: 1500,
						});
						if (model) yield put(getORDERLocations());
						else history.push("/OrderLocations");
					} else {
						swal("Unable to upload file. Please try again!", {
							icon: "error",
							timer: 1500,
						});
					}
				} else {
					swal("Your Order Location Updated Successfully!", {
						icon: "success",
						timer: 1500,
					});
					if (model) yield put(getORDERLocations());
					else history.push("/OrderLocations");
				}
			} else {
				swal("Unable to update Order Location. Please try again!", {
					icon: "error",
					timer: 1500,
				});
			}

			yield put(locationAddSuccessful(null));
		}
	} catch (err) {
		console.error("PUTIMG ERROR:", err);

		let backendData =
			err?.response?.data || // axios error
			err; // plain object error (your case)

		let message = "Something went wrong";
		console.log(backendData, "backendData");
		// If backend returned object like {name: ['error']}
		if (backendData && typeof backendData === "object") {
			const firstKey = Object.keys(backendData)[0];
			const firstValue = backendData[firstKey];

			if (Array.isArray(firstValue)) {
				message = firstValue[0];
			} else if (typeof firstValue === "string") {
				message = firstValue;
			}
		}

		swal(message, { icon: "error", timer: 2000 });
		return;
	}
}

function* DeleteORDERLOCATIONS({ payload: { locId } }) {
	try {
		const response = yield call(
			postDelete,
			"/masters/orderlocations/" + locId
		);
		if (response.status === 204) {
			swal("Poof! Your Product has been deleted!", {
				icon: "success",
			});
			yield put(getORDERLocations());
		} else {
			swal("Sorry! Your Product has been not deleted!", {
				icon: "error",
			});
		}
	} catch (error) {
		swal(error, {
			icon: "error",
		});

		//yield put(apiError(error));
	}
}

//_______________END____________//

export function* watchgetORDERLocations() {
	yield takeEvery(ORDERLOCATIONS, getORDERLocation);
}

export function* watchADDORDERLOCATIONSAdd() {
	yield takeEvery(ORDERLOCATIONS_ADD, ADDORDERLOCATIONS);
}

export function* watchORDERLOCATIONSDelete() {
	yield takeEvery(ORDERLOCATIONS_DELETE, DeleteORDERLOCATIONS);
}

export function* watchORDERLOCATIONSRowData() {
	yield takeEvery(GET_Location_ROW_DATA, GetOrderLocationRowData);
}

function* ORDERLOCATIONSSaga() {
	yield all([
		fork(watchgetORDERLocations),
		fork(watchADDORDERLOCATIONSAdd),
		fork(watchORDERLOCATIONSDelete),
		fork(watchORDERLOCATIONSRowData),
	]);
}

export default ORDERLOCATIONSSaga;
